import React from "react";

function Onboarding(props) {
    const source = props.source || {};
    return (
        <div className="cont-testimonial">
            <p className="testimonial" dangerouslySetInnerHTML={{ __html: `"${source.excerpt}"` }} />
            <img
                className="testimonial-author-avatar"
                src={source.image}
                height="65"
                width="65"
            />
            <p className="testimonial-author-meta">
                {source.name}
                <br />
                <strong>{source.company}</strong>
            </p>
        </div>
    )
}

export { Onboarding }